import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import useImportNameById from 'flow-doctor-lib/hooks/useImportNameById';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const ImportListReferenceDisplayLabel = ({
  importId
}) => {
  const {
    data: importName,
    loading: importNameLoading,
    error: importNameError
  } = useImportNameById({
    portalId: PortalIdParser.get(),
    importId
  });
  if (!importNameError && (importNameLoading || !importName)) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 200
    });
  }
  return /*#__PURE__*/_jsx(UITruncateString, {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "flow-doctor-lib.flows.objectLifecycle.listMembershipHistory.label.import",
      options: {
        importName: importName || importId.toString()
      }
    })
  });
};
export default ImportListReferenceDisplayLabel;